<template>
  <div class="mask-layer mask">
    <div class="container">
      <div class="title">
        选择保险公司
      </div>
      <div class="content">
        <div class="search-box">
          <form @submit.prevent="submit">
            <div class="select-wrap">
              <div class="group margin-right-15">
                <span class="left">保险公司名称</span>
                <div class="right">
                  <input type="text" placeholder="请输入保险公司名称" v-model.trim="model.no">
                </div>
              </div>
              <div class="group btn-box">
                <button type="submit" @click="search" class="btn">搜索</button>
                <button type="button" class="btn">重置</button>
              </div>
            </div>
          </form>
        </div>
        <div class="main_wrap">
          <div class="table_wrap">
            <div class="table_layout">
              <div class="table_scroll ">
                <el-table
                  :data="insuranceCompanyList"
                  max-height="534"
                  border
                  :cell-style="cellStyle"
                  style="width: 100%"
                  :header-cell-style="tableHeaderColor"
                >
                  <el-table-column
                    label="排序"
                    min-width="60"
                    sortable
                    key="1"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{scope.row.id}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="保险公司名称"
                    min-width="100"
                    key="2"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                     {{scope.row.insuranceCompanyName}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    min-width="100"
                    key="3"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span class="primary pointer mr15" @click="choose(scope.row)">选择</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-if="!dataList.length">
                <nt-no-data></nt-no-data>
              </div>
<!--              <div class="pagination insurancePage" v-if="dataList.length">-->
<!--                <nt-pagination ref="child" @fetchData="fetchData"></nt-pagination>-->
                <!--<div class="block">-->
                  <!--<el-pagination-->
                    <!--:current-page="currentPage4"-->
                    <!--:page-sizes="[100, 200, 300, 400]"-->
                    <!--:page-size="100"-->
                    <!--layout="total, sizes, prev, pager, next, jumper"-->
                    <!--:total="400">-->
                  <!--</el-pagination>-->
                <!--</div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <!--<button type="button" class="btn mr20" @click="submitInfo">发送</button>-->
        <button type="button" class="btn" @click="close">取消</button>
      </div>
      <div class="close" @click="close">X</div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "insurance",
    // props:['sendData'],
    data() {
      return {
        model:{
          value1: '',
          id:null,//id
          roleName:null,//角色名称
          projectId:null,//所属系统id
          ruleCode:null,//角色编码
          status:null,//是否启用
          remark:null,//备注

        },
        radio:'1',
        projectList:[],
        dataList:[{}],
        currentPage4: 4,
        insuranceCompanyList:null,
        insuranceShow:false,
        company:{
          insuranceCompanyName:null,
          id:null,
        }

      }
    },
    mounted() {
      this.getInsuranceCompany()
    },
    computed:{
    },
    methods: {
      search(){
        this.insuranceCompanyList.insuranceCompanyName
        this.getInsuranceCompany()
      },
      getInsuranceCompany() {
        this.$axios.get('/admin/insuranceCompany/simpList').then(res => {//保险公司
          if (res.data) {
            this.insuranceCompanyList = res.data.data

          }
        })
      },
      choose(data){
        // this.insuranceCompanyName=data.insuranceCompanyName
        // this.id=data.id
        this.company=data
        this.$emit('func',JSON.stringify(this.company))
      },
      // fetchData(args) {
      // },
      cellStyle({row, column, rowIndex, columnIndex}){
        return 'height:20px;font-size:12px';
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return 'background-color: #f4f5f7;height:40px;color:#4a4a4a!important;font-size:13px'
        }
      },
      // handleSelectionChange(val) {
      //   // this.multipleSelection = val;
      //   val.forEach(item=>{
      //     if(item.range){
      //       item.range=parseFloat(item.range)
      //     }
      //   })
      //   console.log(val)
      //   this.model.rule.accidentRanges=val;
      // },
      close(){
        this.$emit('func',this.insuranceShow);
      },
      // submitInfo(){
      //   this.$validator
      //     .validateAll()
      //     .then((result) => {
      //       if (result) {
      //         this.save();
      //       }
      //     })
      //     .catch(err => {
      //     });
      // },
      // save(){
      //   var msg;
      //   if(this.sendData.id){
      //     msg="编辑成功";
      //   }else{
      //     msg="新增成功";
      //   }
      //   this.$axios.post('/rm-user-manage/api/admin/role/set',this.model).then(res=>{
      //     let data=this.AppUtils.checkResponse(res);
      //     if(data){
      //       console.log(data)
      //       if(data.code==0){
      //         this.$message.success(msg);
      //         this.$emit('hideEditMask');
      //         this.$emit('fetchData');
      //       }
      //     }
      //   });
      // }
    }
  }
</script>

<style scoped lang="scss">
  /*@import '../../assets/css/cover.css';*/
  .systemUl{
    display: flex;
    .systemLi{
      width: 100px;
      line-height: 30px;
      text-align: center;

    }
  }
  .reset{
    position: relative;
    left: -30px;
  }
  .mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .form_item{
    display: flex;
    justify-content: center;
    /*margin-bottom: 15px;*/
  }
  .form_left{
    line-height: 32px;
    margin-right: 10px;
  }
  .form_right{
    line-height: 32px;
    width: 200px!important;
    box-sizing: border-box;
    padding-left: 10px;
    text-align: left;
    height: 45px;
  }
  .container {
    background-color: #fff;
    width: 800px;
    box-sizing: border-box;
    padding-bottom: 10px;
    max-height: 650px;
    position: relative;
    overflow-y: scroll;
    .close{
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      position: absolute;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
    .title{
      height: 41px;
      line-height:41px;
      box-sizing: border-box;
      padding-left: 16px;
      font-family: PingFangSC-Medium;
      font-size: 12px;
      color: #4A4A4A;
      text-align: left;
      border-bottom: 1px solid #ECF1F4;
    }
    .content{
      padding: 16px;
      box-sizing: border-box;
      .topInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 27px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .sendInfo{
        display: flex;
        justify-content: left;
        margin-bottom: 10px;
        span{
          line-height: 21px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
        }
      }
      .infoZone{
        width: 568px;
        height: 250px;
        border: 1px solid #D7D7D7;
        border-radius: 2px;
        position: absolute;
        text-align: left;
        box-sizing: border-box;
        padding: 11px 20px;
        p{
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #4A4A4A;
          a{
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #FF4C00;
          }
        }
        .p1{
          margin-bottom:25px ;
        }
        .p2{
          margin-bottom:11px ;
        }
        .p3{
          margin-bottom:7.5px ;
        }
        textarea{
          position: absolute;
          left: 0;
          top: 0px;
          width: 100%;
          height: 100%;
          resize: none;
          box-sizing: border-box;
          /*padding: 0px 22px;*/
        }
        button{
          position: absolute;
          right:14px ;
          bottom: 9.5px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #FFFFFF;
          background: #1038B7;
          border-radius: 2px;
          padding: 2px 12px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// insurance.vue?2c763a8f